import {useUserContext} from "../providers/UserContext";
import {getButtonClassName} from "../components/common/Button";
import {useEffect, useState,} from "react";
import {Link, useParams} from "react-router-dom";
import {useInboxContext} from "../providers/InboxProvider";
import {useChatListContext} from "../providers/ChatListProvider";
import {WorkspaceMember} from "../lib/types";
export const Dm = ({}: {}) => {
  const { id } = useParams();
  const { setActiveChatId, getMember, user } = useUserContext();
  const [member, setMember] = useState<WorkspaceMember | undefined>(undefined);
  const { inbox } = useInboxContext();
  useEffect(() => {
    if (id) {
      setMember(getMember(id) || undefined);
    }
  }, [inbox, id]);
  const { setChatListSettings, setChatListVisible, setLoadChats,setCurrentFilter } = useChatListContext();
  useEffect(() => {
    if (member) {
      setCurrentFilter("dm_"+id);
      setChatListSettings(`Chats with ${member.displayName}`, inbox.filter(
        chat => {
          const members = Object.keys(chat.userPermissions || {});
          return members.includes(id || "") && members.includes(user?.uid || "");
        }
      ), null);
      setLoadChats(() => inbox.filter(
        chat => {
          const members = Object.keys(chat.userPermissions || {});
          return members.includes(id || "") && members.includes(user?.uid || "");
        }
      )); // Pass the reference as a function
      setActiveChatId("");
      setChatListVisible(true);
    }
  }, [member, inbox]);
  return (
    <div className="flex flex-col gap-1 w-full h-full justify-center items-center">
      <div className="font-style-headline-1 flex items-center mt-[60px]">
          <span>
            Chats with {member?.displayName}
          </span>
      </div>
      <div className={"font-style-body-md text-gray-3 italic"}>
        The conversations you have with {member?.displayName} will appear here.
      </div>
      <div className="actions flex gap-2 mt-4">
        <Link to={`/compose`} className={getButtonClassName()}>
          Compose
        </Link>
      </div>
    </div>
  )
}